import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import { CardHeader, Avatar } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { menuStructure } from 'components/layout/left-panel/PagesMenu';
import { useHistory } from 'react-router-dom';
import PermissionsComponent from 'components/Wrappers/PermissionsComponent';

export const HomePageCtx = React.createContext({});

function HomePageProvider(props) {
  const ctx = {};

  return (
    <HomePageCtx.Provider value={ ctx }>
      {props.children}
    </HomePageCtx.Provider>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.primary.light,
      height: '100%',
    },
    avatar: {
      backgroundColor: theme.palette.primary.dark,
    },
  };
});

export function AppDashboardCard({ title, description, icon, onClick, path }) {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick(); // Use the provided onClick function
    } else if (path) {
      history.push(path); // Default to history.push if onClick is not provided
    }
  };

  return (
    <Card
      onClick={ handleClick }
      className={ classes.root }
    >
      <CardActionArea>
        <CardHeader
          avatar={ (
            <Avatar className={ classes.avatar }>
              {icon && React.createElement(icon)}
            </Avatar>
          ) }
        />
        <CardContent>
          <Typography gutterBottom variant='h5' component='h2'>
            <span style={ { color: 'white' } }>{title}</span>
          </Typography>
          <Typography variant='body2' color='textSecondary' component='p'>
            <span style={ { color: '#ffffff' } }>{description}</span>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

// function HomePageCommercial() { // Dashboard for Commercial users
//   const {
//     oceanBlue: myAccountColor,
//     wetAsphalt: thematicCardColor,
//     seaGreen: b2b,
//     pumpkin: logoutColor,
//   } = getTheme().custom.colors;

//   return (
//     <HomePageProvider>
//       <div>
//         <Grid container direction='column' spacing={ 1 }>
//           <Grid item>
//             <Grid
//               container
//               direction='row'
//               spacing={ 1 }
//             >
//               <Grid item md={ 3 }>
//                 <AppDashboardCard
//                   title='Thematic Packages'
//                   description=''
//                   path='/thematic'
//                   color={ thematicCardColor }
//                   image={ ThematicPackageImg }
//                   height={ 200 }
//                 />
//               </Grid>
//               <Grid item md={ 3 }>
//                 <AppDashboardCard
//                   title='My account'
//                   description=''
//                   path='/my-account'
//                   image={ MyAccountImg }
//                   color={ myAccountColor }
//                   height={ 300 }
//                 />
//               </Grid>
//               <Grid item md={ 3 }>
//                 <AppDashboardCard
//                   title='B2B'
//                   description=''
//                   path='/b2b'
//                   image={ B2BImg }
//                   color={ b2b }
//                   height={ 300 }
//                 />
//               </Grid>
//               <Grid item md={ 3 }>
//                 <AppDashboardCard
//                   title='Reports'
//                   description=''
//                   path='/reports'
//                   image={ ReportsImg }
//                   color={ logoutColor }
//                   height={ 300 }
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </div>
//     </HomePageProvider>
//   );
// }

// function HomePageOther() { // Dashboard for other users
//   const {
//     oceanBlue: myAccountColor,
//     wetAsphalt: thematicCardColor,
//   } = getTheme().custom.colors;
//   return (
//     <HomePageProvider>
//       <div>
//         <Grid container direction='column' spacing={ 1 }>
//           <Grid item>
//             <Grid
//               container
//               direction='row'
//               spacing={ 1 }
//             >
//               <Grid item md={ 6 }>
//                 <AppDashboardCard
//                   title='Thematic Packages'
//                   description=''
//                   path='/thematic'
//                   color={ thematicCardColor }
//                   image={ ThematicPackageImg }
//                   height={ 200 }
//                 />
//               </Grid>
//               <Grid item md={ 6 }>
//                 <AppDashboardCard
//                   title='My account'
//                   description=''
//                   path='/my-account'
//                   image={ MyAccountImg }
//                   color={ myAccountColor }
//                   height={ 300 }
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </div>
//     </HomePageProvider>
//   );
// }

function HomePage() {
  const history = useHistory();

  const handleCardClick = (key) => {
    if (key === 'users') {
      history.push('/users');
    } else {
      history.push(`/submenu/${ key }`);
    }
  };

  return (
    <HomePageProvider>
      <div>
        <Grid container direction='column' spacing={ 1 }>
          <Grid item>
            <Grid
              container
              direction='row'
              spacing={ 1 }
            >
              {menuStructure.map((item) => {
                return (
                  <PermissionsComponent
                    key={ item.key }
                    permissions={ item.permission }
                  >
                    <Grid item sm={ 6 } md={ 4 } lg={ 4 } key={ item.key }>
                      <AppDashboardCard
                        title={ item.title }
                        description={ item.description }
                        path={ item.path }
                        icon={ item.icon }
                        onClick={ () => { return handleCardClick(item.key); } }
                      />
                    </Grid>
                  </PermissionsComponent>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </HomePageProvider>
  );
}

export default HomePage;
